'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import {
  styled,
  Flex,
  $fontWeightLight,
  $fontWeightBolder,
  $fontSize,
  Box,
} from '@acko-tech/building-blocks.ui.common'
import { Text } from '@acko-tech/building-blocks.ui.typography'
import Image from 'next/image'

export const FaqContainer = styled(Flex)`
  flex-direction: column;
  box-sizing: border-box;
  max-width: 1068px;
  margin-left: auto;
  margin-right: auto;
  scroll-margin-top: 80px;

  @media screen and (max-width: 425px) {
    padding: 40px 30px;
  }

  @media screen and (max-width: 1140px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`

export const FaqAccordianHeader = styled(Flex)`
  align-items: center;
  font-size: ${$fontSize.xxs};
  font-weight: ${$fontWeightBolder};
  padding-bottom: 20px;
  padding-top: 20px;
  cursor: pointer;
`

export const FaqParagraph = styled(Text)`
  font-weight: ${$fontWeightLight};
  font-size: ${$fontSize.xs};
  margin-bottom: 30px;
  line-height: 24px;
  color: #5b5675;
`

export const FaqUnorderedList = styled.ul`
  padding-left: 30px;
  box-sizing: border-box;
`

export const FaqOrderedList = styled.ol`
  padding-left: 30px;
  box-sizing: border-box;
`

export const FaqAccordionWrap = styled(Flex)`
  &#accordianwrap {
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid #e7e7f0;
    margin-bottom: 12px;
    transform: initial;

    @media screen and (min-width: 426px) {
      margin-bottom: 20px;
    }
  }
`

export const FaqStyledImage = styled(Image)`
  width: 14px !important;
  height: 14px !important;

  transform: ${props => (props.isopen === 'true' ? 'rotate(180deg)' : 'rotate(0deg)')};
  &.rotate {
    transform: rotate(180deg);
  }
`

export const FaqParaHeading = styled.p`
  display: block;
  font-size: ${props => (props.customFontSize ? props.customFontSize : $fontSize.normal)};
  font-weight: 500;
  color: ${props => (props.colorVal ? props.colorVal : '#040222')};
`

export const FaqStrongHeading = styled.strong`
  display: block;
  font-weight: 600;
  font-size: 1rem;
  color: rgb(21, 22, 25);
  margin-bottom: 10px;
`

export const FaqAccordianContent = styled(Box)`
  ${props => (props.noMarginTop ? '' : 'margin-top: 18px')};
  display: ${props => (props.show ? 'block' : 'none')};
`

export const FaqLinkTag = styled.a`
  color: #1b73e8;
  text-decoration: underline;
  cursor: pointer;
  vertical-align: baseline;
`
